/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: YACCL_iSDMYi

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHeaderMenuItem.module.css"; // plasmic-import: YACCL_iSDMYi/css

import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: LisDN3qMspXl/icon

createPlasmicElementProxy;

export type PlasmicHeaderMenuItem__VariantMembers = {
  active: "active";
};
export type PlasmicHeaderMenuItem__VariantsArgs = {
  active?: SingleBooleanChoiceArg<"active">;
};
type VariantPropType = keyof PlasmicHeaderMenuItem__VariantsArgs;
export const PlasmicHeaderMenuItem__VariantProps = new Array<VariantPropType>(
  "active"
);

export type PlasmicHeaderMenuItem__ArgsType = {
  name?: string;
  link?: string;
  onClick?: () => void;
};
type ArgPropType = keyof PlasmicHeaderMenuItem__ArgsType;
export const PlasmicHeaderMenuItem__ArgProps = new Array<ArgPropType>(
  "name",
  "link",
  "onClick"
);

export type PlasmicHeaderMenuItem__OverridesType = {
  features?: Flex__<"a"> & Partial<LinkProps>;
  text3?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultHeaderMenuItemProps {
  name?: string;
  link?: string;
  onClick?: () => void;
  active?: SingleBooleanChoiceArg<"active">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHeaderMenuItem__RenderFunc(props: {
  variants: PlasmicHeaderMenuItem__VariantsArgs;
  args: PlasmicHeaderMenuItem__ArgsType;
  overrides: PlasmicHeaderMenuItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "active",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.active
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <PlasmicLink__
      data-plasmic-name={"features"}
      data-plasmic-override={overrides.features}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      aria-label={(() => {
        try {
          return $props.name;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.features,
        { [sty.featuresactive]: hasVariant($state, "active", "active") }
      )}
      component={Link}
      href={$props.link}
      legacyBehavior={false}
      onClick={async event => {
        const $steps = {};

        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      platform={"nextjs"}
      title={(() => {
        try {
          return $props.name;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"text3"}
        data-plasmic-override={overrides.text3}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text3,
          { [sty.text3active]: hasVariant($state, "active", "active") }
        )}
      >
        <React.Fragment>{$props.name}</React.Fragment>
      </div>
      {false ? (
        <Icon4Icon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg)}
          role={"img"}
        />
      ) : null}
    </PlasmicLink__>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  features: ["features", "text3", "svg"],
  text3: ["text3"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  features: "a";
  text3: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHeaderMenuItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHeaderMenuItem__VariantsArgs;
    args?: PlasmicHeaderMenuItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHeaderMenuItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHeaderMenuItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHeaderMenuItem__ArgProps,
          internalVariantPropNames: PlasmicHeaderMenuItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHeaderMenuItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "features") {
    func.displayName = "PlasmicHeaderMenuItem";
  } else {
    func.displayName = `PlasmicHeaderMenuItem.${nodeName}`;
  }
  return func;
}

export const PlasmicHeaderMenuItem = Object.assign(
  // Top-level PlasmicHeaderMenuItem renders the root element
  makeNodeComponent("features"),
  {
    // Helper components rendering sub-elements
    text3: makeNodeComponent("text3"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicHeaderMenuItem
    internalVariantProps: PlasmicHeaderMenuItem__VariantProps,
    internalArgProps: PlasmicHeaderMenuItem__ArgProps
  }
);

export default PlasmicHeaderMenuItem;
/* prettier-ignore-end */
